export enum CrewMemberControlTypeEnum {
  PIC = 1,
  SIC = 2,
  FT = 3,
  FA = 4
}
